
<nlf-ors-editor-tag-e5x-render [classes]="classes" *ngIf="!!value" [showLabel]="showLabel" [items]="value"
    [path]="e5xPath">
</nlf-ors-editor-tag-e5x-render>
<nlf-ui-component-spinner size="1" *ngIf="!value"></nlf-ui-component-spinner>